import * as React from 'react'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'

import { Field, InputBorder } from 'mf-ui-components'

import { fontSize } from '../../utils/style/fontSize'

const Amount = styled(NumberFormat)`
  border: none;
  padding: 0 16px;
  background: transparent;
  width: 100%;
  line-height: ${({ theme }) => theme.typography.font.sizes.normal}px;
  font-size: ${fontSize('normal')};
  color: ${({ theme }) => theme.tokens.text.label.regular};
  outline: none;
`

const StyledIcon = styled.span`
  padding: 12px 0px 14px 16px;
  color: ${({ theme }) => theme.tokens.text.label.lighter};
  font-size: ${fontSize('normal')};
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
`

export const ContributionField = ({
  label,
  locale,
  value,
  onChange,
  onBlur,
  onKeyDown,
  decimalScale,
  error,
}) => (
  <Field label={label} error={error}>
    <InputBorder>
      <StyledIcon>{locale === 'GB' ? '£' : '€'}</StyledIcon>
      <Amount
        value={value}
        onBlur={onBlur}
        onValueChange={onChange}
        type="text"
        decimalScale={decimalScale}
        thousandSeparator={locale === 'GB' ? ',' : '.'}
        decimalSeparator={locale === 'GB' ? '.' : ','}
        allowNegative={false}
        onKeyDown={onKeyDown}
      />
    </InputBorder>
  </Field>
)
